/**
 * @generated SignedSource<<6fcedeadad04e74b95c1834a16b6cdba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CategoryListRow_category$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "CategoryListRow_category";
};
export type CategoryListRow_category$key = {
  readonly " $data"?: CategoryListRow_category$data;
  readonly " $fragmentSpreads": FragmentRefs<"CategoryListRow_category">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryListRow_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "Category",
  "abstractKey": null
};

(node as any).hash = "1a43b4bc4c0cc19ba86f6060d167a407";

export default node;
